<template>
  <div class="case-prize">
    <div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" @click="handleAdd">添加盒子奖品</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSort">按价格排序</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="openSetPriceDialog"
            >价格设置</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            v-show="Number($route.query.cid) === 4"
            @click="openSetprobabilityDialog"
            >同步对战概率</el-button
          >
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="synchronousBattleProbability">同步对战概率</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleUpdatePrice">更新到手动价格</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-switch
            v-model="updateFlag"
            :active-value="1"
            :inactive-value="0"
            active-text="手动更新开"
            inactive-text="手动更新关"
            @change="handleSwitch"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="id" label="奖品ID" width="100px">
          <template slot-scope="{ row }">
            <span :class="`${row.is_battle ? 'battle_prize' : ''}`">
              {{ row.prize_id }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="奖品名称">
          <template slot-scope="{ row }">{{ row.name }}</template>
        </el-table-column>
        <el-table-column prop="second_name" label="第二名称">
          <template slot-scope="{ row }">{{ row.second_name }}</template>
        </el-table-column>
        <el-table-column label="图片" width="100px">
          <template slot-scope="{ row }">
            <img width="80" class="table-image" :src="row.image" alt />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格">
          <template slot-scope="{ row }"><span :style="now_box_type != 4 ? 'color: blue' : ''">{{
              row.price
          }}</span></template>
        </el-table-column>
        <el-table-column prop="mhb_price" label="对战价格">
          <template slot-scope="{ row }"><span :style="now_box_type == 4 ? 'color: blue' : ''">{{
              row.mhb_price
          }}</span></template>
        </el-table-column>
        <el-table-column prop="price" label="暗金">
          <template slot-scope="{ row }">
            <span v-if="row.darkgoldenrod === 1">暗金：普通"</span>
            <span v-if="row.darkgoldenrod === 2">暗金：StatTrak™"</span>
            <span v-if="row.darkgoldenrod === 3">暗金：★StatTrak™"</span>
            <span v-if="row.darkgoldenrod === 4">暗金：★"</span>
            <span v-if="row.darkgoldenrod === 5">暗金：纪念品"</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="自动更新价格">
          <template slot-scope="{ row }">{{ row.auto_price }}</template>
        </el-table-column> -->
        <el-table-column label="IG最新价格">
          <template slot-scope="{ row }">{{ row.ig_prize }}</template>
        </el-table-column>
        <el-table-column label="更新前价格">
          <template slot-scope="{ row }">{{ row.before_price }}</template>
        </el-table-column>
        <el-table-column label="zbt最新价格">
          <template slot-scope="{ row }">{{ row.zbt_prize }}</template>
        </el-table-column>
        <el-table-column prop="category_id" label="所属分类">
          <template slot-scope="{ row }">{{
              getCategoryName(row.category_id)
          }}</template>
        </el-table-column>
        <el-table-column label="价格更新类型">
          <template slot-scope="{ row }">
            <span v-if="row.price_up_type == 1">自动</span>
            <span v-if="row.price_up_type == 2">手动</span>
            <span v-if="row.price_up_type == 3">不更新</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="等级">
          <template slot-scope="{ row }">
            <span :style="`color: ${getRankColor(row.rank)};`">{{
                getRank(row.rank)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="权重"></el-table-column>
        <el-table-column prop="display_probability" label="显示概率"></el-table-column>
        <el-table-column prop="true_probability" label="真实概率"></el-table-column>
        <el-table-column prop="delivery_type" label="发货方式">
          <template slot-scope="{ row }">
            <span v-if="row.delivery_type === 1">手动发货</span>
            <span v-if="row.delivery_type === 2">机器人发货</span>
            <span v-if="row.delivery_type === 3">扎比特发货(人工手动)</span>
            <span v-if="row.delivery_type === 4">扎比特发货(自动脚本)</span>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="{ row }">
            <span :style="`color: ${row.number < 20 ? '#c00' : '#333'};`">{{
                row.number
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="300px">
          <template slot-scope="{ row }">
            <el-button style="margin-bottom: 10px" type="primary" plain @click="openPriceLog(row)">价格记录</el-button>
            <el-button type="primary" plain @click="handleEditPrize(row)">饰品</el-button>
            <el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
            <el-button type="primary" @click="handleChangeNumber(row, row.number)">修改数量</el-button>
            <el-button type="danger" @click="handleDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0" :current-page="page"
      @current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    <el-dialog :visible.sync="visible" :title="isEdit ? '编辑奖品' : '添加奖品'" width="400px" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px" :rules="rules" ref="form">
        <el-form-item prop="prize_id" label="奖品">
          <div v-if="selectedPrize" class="prize-item">
            <img width="80" :src="selectedPrize.image" alt />
            <p>
              <span>{{ selectedPrize.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
                  getRank(selectedPrize.rank)
              }}</span>
              <span class="price">${{ selectedPrize.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="visiblePrize = true">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item>
        <el-form-item prop="display_probability" label="显示概率">
          <el-input v-model="formData.display_probability" placeholder="显示给用户的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="true_probability" label="真实概率">
          <el-input v-model="formData.true_probability" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="new_probability" label="新人概率">
          <el-input v-model="formData.new_probability" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="l_one" label="L1概率">
          <el-input v-model="formData.l_one" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="l_two" label="L2概率">
          <el-input v-model="formData.l_two" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="l_three" label="L3概率">
          <el-input v-model="formData.l_three" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="l_four" label="L4概率">
          <el-input v-model="formData.l_four" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>
        <el-form-item prop="l_five" label="L5概率">
          <el-input v-model="formData.l_five" placeholder="抽奖算法真实的概率(0-100)"></el-input>
        </el-form-item>

        <el-form-item prop="weight" label="权重">
          <el-input v-model="formData.weight" placeholder="权重"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="visiblePrize" title="奖品列表" :close-on-click-modal="false" width="930px">
      <el-row style="margin-bottom: 20px">
        <el-input style="width: 200px; margin-right: 20px" placeholder="奖品名称搜索" v-model="query.prizeName"></el-input>
        <el-input v-model="query.min_price" placeholder="最小价格" style="width: 150px; margin-right: 5px"></el-input>
        -
        <el-input v-model="query.max_price" placeholder="最大价格"
          style="width: 150px; margin-left: 5px; margin-right: 20px"></el-input>
        <el-select
            v-model="query.is_gold"
            placeholder="is_gold"
            size="small"
            style="width: 150px; margin-left: 5px; margin-right: 20px"
        >
          <el-option :value="undefined">全部</el-option>
          <el-option :value="2">0</el-option>
          <el-option :value="1">1</el-option>
        </el-select>
        <el-button type="primary" @click="getPrize(1)">搜索</el-button>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i class="el-icon-plus" title="添加" @click="handleAddPrize(item)"></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span v-if="item.darkgoldenrod === 1">普通</span>
              <span v-if="item.darkgoldenrod === 2">StatTrak™</span>
              <span v-if="item.darkgoldenrod === 3">★StatTrak™</span>
              <span v-if="item.darkgoldenrod === 4">★</span>
              <span v-if="item.darkgoldenrod === 5">纪念品</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                  getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination background :page-size="prizeListMeta.per_page || 15" :total="prizeListMeta.total || 0"
        :current-page="prizeListMeta.current_page" @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"></el-pagination>
    </el-dialog>
    <el-dialog :visible.sync="visibleEditPrize" title="编辑奖品" width="400px" destroy-on-close
      :close-on-click-modal="false">
      <el-form :model="formPrizeData" label-width="100px" :rules="rules" ref="form">
        <el-form-item prop="name" label="奖品名称">
          <el-input v-model="formPrizeData.name"></el-input>
        </el-form-item>
        <el-form-item prop="second_name" label="第二名称">
          <!-- <el-input v-model="formPrizeData.second_name"></el-input> -->
          <el-autocomplete style="width: 280px" class="inline-input" v-model="formPrizeData.second_name"
            :fetch-suggestions="querySearch" placeholder="请输入内容"></el-autocomplete>
        </el-form-item>
        <el-form-item prop="image" label="图片">
          <el-upload class="avatar-uploader" :action="action" :data="{ disk: imgType }" :show-file-list="false"
            :on-success="handleUploadSuccess" :before-upload="beforeImageUpload" :headers="headers" accept="image/*"
            name="file">
            <img class="avatar" width="100" v-if="formPrizeData.image" :src="formPrizeData.image" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸256 * 192（4:3）</p>
        </el-form-item>
        <el-form-item prop="price" label="价格">
          <el-input v-model="formPrizeData.price"></el-input>
        </el-form-item>
        <el-form-item prop="price" label="对战价格">
          <el-input v-model="formPrizeData.mhb_price"></el-input>
        </el-form-item>
        <el-form-item prop="price_up_type" label="价格更新类型">
          <el-select v-model="formPrizeData.price_up_type">
            <el-option :value="1" label="自动"> </el-option>
            <el-option :value="2" label="手动"> </el-option>
            <el-option :value="3" label="不更新"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="category_id" label="奖品分类">
          <el-select v-model="formPrizeData.category_id" placeholder="请选择奖品分类">
            <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="rank" label="等级">
          <el-select v-model="formPrizeData.rank">
            <el-option v-for="item in ranks" :key="item.level" :value="item.level" :label="item.text">
              <span :style="`color: ${item.color};`">{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="wear_degree" label="磨损度">
          <el-select v-model="formPrizeData.wear_degree">
            <el-option :value="100" label="无"> </el-option>
            <el-option v-for="item in quality" :key="item.degree" :value="item.degree" :label="item.text">
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="delivery_type" label="发货方式">
          <el-select v-model="formPrizeData.delivery_type">
            <el-option v-for="item in deliveryType" :key="item.value" :value="item.value" :label="item.text">
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="number" label="数量" v-if="!isEdit">
          <el-input v-model="formPrizeData.number" placeholder="奖品初始数量"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleEditPrize = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitEdit" :loading="buttonLoadingEditPrize">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 同步对战概率 -->
    <SynchronizationProbability v-model="now_box_id" :visible="probabilityVisible" @close="probabilityVisible = false">
    </SynchronizationProbability>
    <!-- 价格设置 -->
    <SetPrice v-model="now_box_id" :visible="setPriceVisible" @close="setPriceVisible = false"></SetPrice>

    <!-- 价格记录 -->
    <PriceLogDialog :visible="logsVisible" v-model="dialogInfos" @close="logsVisible = false"></PriceLogDialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import saveFile from '@/utils/saveFile'
import http, { api, server, postData, delData, patchData, getData, getApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import SynchronizationProbability from '@/components/case/SynchronizationProbability.vue'
import SetPrice from '@/components/case/SetPrice.vue'
import PriceLogDialog from '@/components/case/PriceLogDialog.vue'
import quality from '@/utils/quality'
import deliveryType from '@/utils/deliveryType'
import ranks from '@/utils/ranks'

export default {
  components: {
    SynchronizationProbability,
    SetPrice,
    PriceLogDialog
  },
  props: {
    // now_box_id: {
    //   type: String,
    //   default: undefined
    // }
  },
  data() {
    this.ranks = ranks
    return {
      updateFlag: 0,//开关状态 0是关闭，1是打开
      logsVisible: false,//价格记录弹窗显示标志
      setPriceVisible: false,//价格设置弹窗显示标志
      probabilityVisible: false,//同步概率弹窗显示标志
      dialogInfos: undefined,//弹窗传递数据
      imgType: 'prize',//上传图片的种类 奖品
      quality,
      deliveryType,
      formData: {
        prize_id: undefined,
        display_probability: '',
        true_probability: '',
        weight: undefined,
        new_probability: '',
        l_one: '',
        l_two: '',
        l_three: '',
        l_four: '',
        l_five: '',
      },
      formPrizeData: {
        name: '',
        second_name: '',
        image: '',
        price: '',
        mhb_price: '',
        rank: 1,
        category_id: 1,
        price_up_type: 3,//默认不更新
        wear_degree: 0,
        number: '',
        delivery_type: 1
      },
      rules: {
        prize_id: [{ required: true, message: '请选择要添加到奖品' }],
        display_probability: [{ required: true, message: '请输入显示概率' }],
        true_probability: [{ required: true, message: '请输入真实概率' }]
      },
      query: {//搜索信息
        page: 1,
        prizeName: '',
        min_price: undefined,
        max_price: undefined,
        is_gold: undefined
      },
      page: 1,
      editInfo: undefined,
      loading: false,
      visible: false,
      buttonLoading: false,
      isEdit: false,
      dataList: undefined,
      dataMeta: {},
      visiblePrize: false,
      loadingPrize: false,
      prizeList: undefined,
      prizeListMeta: undefined,
      selectedPrize: undefined,
      isEditPrize: false,
      editPrizeInfo: undefined,
      visibleEditPrize: false,
      buttonLoadingEditPrize: false,
      battleList: undefined,//对战物品的列表
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    cid() {
      return this.$route.query.cid
    },
    now_box_id() {
      return this.$route.query.now_box_id
    },
    now_box_type() {
      return this.$route.query.now_box_type
    }
  },
  watch: {
    visible(val) {
      if (this.editInfo) {
        const { display_probability, true_probability, weight, new_probability, l_one, l_two, l_three, l_four, l_five } = this.editInfo
        this.formData = {
          ...this.formData,
          true_probability,
          display_probability,
          weight,
          new_probability,
          l_one,
          l_two,
          l_three,
          l_four,
          l_five
        }
      } else {
        if (this.$refs['form']) {
          this.$refs['form'].resetFields()
          this.formData = {
            prize_id: undefined,
            display_probability: '',
            true_probability: '',
            weight: undefined,
            new_probability: '',
            l_one: '',
            l_two: '',
            l_three: '',
            l_four: '',
            l_five: '',
          }
          this.selectedPrize = undefined
        }
      }
    }
  },
  created() {
    this.getData()
    this.getPrize(1)
    !this.categories && this.getCategories()
    // this.getSwitchStatus()
  },
  methods: {
    ...mapActions(['getCategories']),
    handleSort() {
      //按价格排序
      getData(`box_price_set/${this.now_box_id}`)
        .then(res => {
          this.getData()//刷新数据
        })
        .finally(() => {
        })
    },
    // 同步对战概率
    synchronousBattleProbability() {
      getData(`battle_price_set/${this.now_box_id}`)
        .then(res => {
          //刷新当前页面
          this.getData()
          this.getPrize()
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    openSetPriceDialog() {
      //打开价格设置
      this.setPriceVisible = true
    },
    openSetprobabilityDialog() {
      //打开同步概率弹窗
      this.probabilityVisible = true
    },
    getRank(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getData(num) {
      let params = {
        page: this.page
      }
      this.loading = true
      getData(`box_prize/${this.now_box_id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPrize(num) {
      if (!this.cid) {
        return
      }
      if (num === 1) {
        this.query.page = 1
      }

      let params = {
        category_id: this.cid,
        page: this.query.page,
        name: this.query.prizeName,
        min_price: this.query.min_price,
        max_price: this.query.max_price,
        is_gold: this.query.is_gold
      }

      this.loadingPrize = true
      getData(`prize`, params)
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.formPrizeData.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['form'].validateField('image')
    },
    handleAdd() {
      this.isEdit = false
      this.editInfo = undefined
      this.visible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editInfo = row
      this.visible = true
      this.selectedPrize = row
      // this.formData.prize_id = row.id
      this.formData.prize_id = row.prize_id
    },
    openPriceLog(rowInfo) {
      //打开价格记录弹窗
      this.logsVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      this.dialogInfos.now_box_type=this.now_box_type
    },
    handleEditPrize(row) {
      this.isEditPrize = true
      this.editPrizeInfo = row
      this.formPrizeData = JSON.parse(JSON.stringify(row))
      this.visibleEditPrize = true
    },
    handleAddPrize(row) {
      this.formData.prize_id = row.id
      this.selectedPrize = row
      this.visiblePrize = false
    },
    handleRemovePrize() {
      this.formData.prize_id = undefined
      this.selectedPrize = undefined
    },
    handlePageChange(page) {
      this.page = page
      this.getData()
    },
    handlePrizePageChange(page) {
      this.query.page = page
      this.getPrize()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delData(`box_prize/${id}`).then(res => {
          this.$message.success(res.message ? res.message : '操作成功!')
          this.getData()
        })
      })
    },
    handleChangeNumber(rowInfo, number) {
      this.$prompt('', '修改奖品数量', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // inputPlaceholder: '正值增加，负值减少',
        customClass: 'change-prize-number',
        closeOnClickModal: false,
        inputPattern: /^(\-?)\d+(\.\d+)?$/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        if (parseInt(number) + parseInt(value) < 0) {
          this.$message.error('奖品数量不能为负')
          return
        }
        patchData(`prize/${rowInfo.prize_id}`, {
          number: value
        }).then(res => {
          this.$message.success(res.message ? res.message : '操作成功!')
          this.getData()
        })
      })
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          if (!this.editInfo) {
            postData(`box_prize`, {
              ...this.formData,
              box_id: this.now_box_id
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success(res.message ? res.message : '操作成功!')
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          } else {
            patchData(`box_prize/${this.editInfo.id}`, this.formData)
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success(res.message ? res.message : '操作成功!')
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          }
        }
      })
    },
    submitEdit() {
      this.formPrizeData.box_type = this.cid
      patchData(`prize/${this.editPrizeInfo.prize_id}`, {
        ...this.formPrizeData
      })
        .then(res => {
          this.buttonLoadingEditPrize = false
          this.visibleEditPrize = false
          this.$message.success(res.message ? res.message : '操作成功!')
          this.getData()
        })
        .finally(() => {
          this.buttonLoadingEditPrize = false
        })
    },
    handleExport() {
      http
        .get(
          api + `box_prize_export/${this.now_box_id}`,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '盒子物品表.xlsx'
          })
        }).finally(() => {
        })
    },
    handleUpdatePrice() {
      //更新到手动价格
      this.$confirm('确定要更新吗？', {
        type: 'warning'
      }).then(res => {
        postData(`auto_up_price/${this.now_box_id}`)
          .then(res => {
            this.$message.success('操作成功!')
            this.getData()
          })
          .finally(() => {
          })
      })
    },
    getSwitchStatus() {
      //获取关闭/打开更新开关状态
      let params = { key: 'prize_price_manual' }
      getApiData('system_config_enable', params).then(res => {
        if (res) {
          res.enable ? this.updateFlag = 1 : this.updateFlag = 0
        }
      }).finally(() => {
      })
    },
    handleSwitch() {
      //关闭/打开更新开关状态
      let params = {
        key: 'prize_price_manual',
        val: this.updateFlag
      }
      patchApiData('system_config_enable', params).then(res => {
        this.$message.success('操作成功！')
        this.getSwitchStatus()//刷新
      })
    },
    querySearch(queryString, cb) {
      //第二名称，下拉选择
      let restaurants = []
      for (let i = 0; i < quality.length; i++) {
        let obj = {
          "value": quality[i].text
        }
        restaurants.push(obj)
      }
      cb(restaurants);
    },
  },
}
</script>
<style lang="less" scoped>
.battle_prize {
  background-color: red;
  color: #fff;
}
</style>
